<template>
  <b-container>
    <strong>Loading...</strong>
    <b-spinner class="ml-4" variant="primary" label="loading"></b-spinner>
  </b-container>
</template>

<script>
export default {
  name: "TheSpinner",
};
</script>

<style scoped></style>
